$(window).on("load", function() {
    if($("a").is(".rap__med__prev")) {
        $('.rap__med__prev').addClass('rap__med__prev-disabled');
        clickArrowNext();
    }
    else {
        setTimeout(function(){
            $('.rap__med__prev').addClass('rap__med__prev-disabled');
            clickArrowNext()
        }, 1000);
    }
    setTimeout(function(){
        firstPopupElement()
    }, 1000);
});

function clickArrowNext() {
    $('.rap__med__next, .rap__med__prev').click(function(){
        var firstElement = $('#rap__med__insta #rap__med__instabox').first();
        if (firstElement.hasClass("active")) {
            $('.rap__med__prev').addClass('rap__med__prev-disabled');
        }
        else {
            $('.rap__med__prev').removeClass('rap__med__prev-disabled');
        }
    });
}

function firstPopupElement() {
    var firstPopupElement = $('.rap__med__insta__popup .rap__med__instaoverlay').first();
    firstPopupElement.addClass('acivePopupNoLeftArrow');
}




